import utils from "@utils";

const defaultIssueDate = timeZoneId =>
	utils.formatDate(
		new Date(),
		utils.isDesktopSafari || utils.isIE ? "en-US" : undefined,
		timeZoneId,
		"2-digit",
	);

export const NONRKPAYINVOICE_ACTIONS = {
	SET_PAYMENT_DATA: "SET_PAYMENT_DATA",
	SET_BILLING_CONTACT: "SET_BILLING_CONTACT",
	SET_INVOICE_PROPERTY_DATA: "SET_INVOICE_PROPERTY_DATA",
	SET_FROM_PROPERTY_DATA: "SET_FROM_PROPERTY_DATA",
	SET_BILL_TO_PROPERTY_DATA: "SET_BILL_TO_PROPERTY_DATA",
	SET_BILL_TO_STATE_DATA: "SET_BILL_TO_STATE_DATA",
	SET_LINE_ITEM_POSITION: "SET_LINE_ITEM_POSITION",
	SET_NEW_LINE_FEE_TOGGLER: "SET_NEW_LINE_FEE_TOGGLER",
	SET_LINE_ITEMS: "SET_LINE_ITEMS",
	ADD_LINE_ITEMS: "ADD_LINE_ITEMS",
	ADD_NEW_LINE_ITEM_FEE: "ADD_NEW_LINE_ITEM_FEE",
	OVERRIDE_LINE_ITEMS: "OVERRIDE_LINE_ITEMS",
	HANDLE_INVOICE_DATA: "HANDLE_INVOICE_DATA",
	HANDLE_CLIENT_CHANGE: "HANDLE_CLIENT_CHANGE",
	REMOVE_LINE_ITEM: "REMOVE_LINE_ITEM",
	TOGGLE_LINE_FEES: "TOGGLE_LINE_FEES",
	HANDLE_INOVICE_DRAFT_TOTALS: "HANDLE_INOVICE_DRAFT_TOTALS",
	RESET_LINE_ITEMS_CHANGED_STATE: "RESET_LINE_ITEMS_CHANGED_STATE",
	SET_ADDITIONAL_FEES_TOTALS: "SET_ADDITIONAL_FEES_TOTALS",
	SET_INITIAL_INVOICE_INFO_FROM_USER: "SET_INITIAL_INVOICE_INFO_FROM_USER",
	CLEAR_LINE_ITEMS: "CLEAR_LINE_ITEMS",
	CONVERT_TO_INVOICE: "CONVERT_TO_INVOICE",
	TOGGLE_OFFICER_VIEW: "TOGGLE_OFFICER_VIEW",
};

export const builNonRKPayInvoiceInitialState = TimeZoneId => ({
	archived: false,
	finalized: false,
	estimateFinalized: false,
	voided: false,
	amended: false,
	disputed: false,
	electronicPaymentsMade: false,
	issueDate: defaultIssueDate(TimeZoneId),
	dueDate: "",
	isEstimate: false,
	sentDateTimeUTC: null,
	statusId: null,
	invoiceId: "",
	invoiceNumber: "",
	notesToClient: "",
	invoiceDisclaimer: "",
	profilePicUrl: "",
	typeId: null,
	from: {
		name: "",
		address: "",
		phone: "",
		email: "",
		contact: "",
	},
	billTo: {
		streetAddress: "",
		city: "",
		stateId: "",
		stateName: "",
		stateAbbreviation: "",
		zip: "",
		phone: "",
		email: "",
		contact: "",
	},
	prePay: false,
	invoiceVersion: null,
	lineItems: [],
	showDelete: "",
	lineFeeToggler: {},
	newLineFeeToggler: {},
	officerViewList: [],
	showFeesBreakdown: false,
	totals: {
		hourlyTotal: 0,
		feesTotal: 0,
		agencyFeesTotal: 0,
		vehicleFeesTotal: 0,
		equipmentFeesTotal: 0,
		coordinationFeesTotal: 0,
		miscPersonnelFeesTotal: 0,
		additionalFees: [],
		totalDue: 0,
		appliedPayments: 0,
		payments: 0,
		refunds: 0,
		tax: null, // Not calculated until invoice has been created
		serviceFee: null, // Not calculated until invoice has been created
		workerCompensationFee: null, // Not calculated until invoice has been created
		balance: 0,
		subTotal: 0,
	},
});

export const nonRKPayInvoiceRecuder = (state, action) => {
	switch (action.type) {
		case NONRKPAYINVOICE_ACTIONS.TOGGLE_OFFICER_VIEW: {
			const sortedLineItems = state.lineItems.sort((a, b) =>
				state.officerViewList.length === 0
					? (b.OfficerId || 0) - (a.OfficerId || 0)
					: utils.compareLineItemsByDateAndOfficerName(a, b),
			);

			const uniqueOfficers = [
				...new Set(sortedLineItems.map(i => `${i.OfficerName}_${i.OfficerId}`)),
			].map(comb => {
				const [name, id] = comb.split("_");
				return {
					OfficerName: name,
					OfficerId: parseInt(id, 10) || null,
				};
			});

			return {
				...state,
				lineItems: sortedLineItems,
				officerViewList: state.officerViewList.length === 0 ? uniqueOfficers : [],
			};
		}

		case NONRKPAYINVOICE_ACTIONS.CONVERT_TO_INVOICE: {
			const { invoiceNumber, dueDate, issueDate } = action.payload;

			return {
				...state,
				invoiceNumber,
				dueDate,
				issueDate,
				isEstimate: false,
			};
		}

		case NONRKPAYINVOICE_ACTIONS.CLEAR_LINE_ITEMS:
			return {
				...state,
				lineItems: [],
				lineFeeToggler: {},
				newLineFeeToggler: {},
				showDelete: "",
			};

		case NONRKPAYINVOICE_ACTIONS.SET_INITIAL_INVOICE_INFO_FROM_USER: {
			const {
				isEstimate,
				invoiceVersion,
				user: {
					JurisdictionName,
					JurisdictionStreetAddress,
					StreetAddress,
					City,
					JurisdictionStateAbbreviation,
					StateAbbreviation,
					JurisdictionZip,
					Zip,
					CellPhone,
					Email,
					FirstName,
					LastName,
					Organization: { OrganizationLogo, Name: organizationName },
				},
			} = action.payload;

			const streetAddress = JurisdictionStreetAddress || StreetAddress;
			const city = City;
			const userState = JurisdictionStateAbbreviation || StateAbbreviation;
			const zip = JurisdictionZip || Zip;

			let address = streetAddress;
			if (streetAddress && (city || userState || zip)) address += "\n";
			address += `${city || ""}${city && userState ? ", " : ""}${userState}${(city || userState) && zip ? " " : ""}${zip}`;

			return {
				...state,
				isEstimate,
				prePay: invoiceVersion === 3 ? !!isEstimate : false,
				profilePicUrl: OrganizationLogo || "",
				from: {
					...state.from,
					name: organizationName || JurisdictionName || "",
					address,
					phone: utils.formatPhoneNumber(CellPhone),
					email: Email || "",
					contact: `${FirstName || ""}${!!FirstName && !!LastName ? " " : ""}${LastName || ""}`,
				},
			};
		}

		case NONRKPAYINVOICE_ACTIONS.SET_ADDITIONAL_FEES_TOTALS:
			return {
				...state,
				totals: {
					...state.totals,
					additionalFees: action.payload,
				},
			};

		case NONRKPAYINVOICE_ACTIONS.ADD_NEW_LINE_ITEM_FEE: {
			const { lineItems, jobAssignmentId } = action.payload;
			return {
				...state,
				lineItems,
				newLineFeeToggler: {
					...state.newLineFeeToggler,
					[jobAssignmentId]: undefined,
				},
			};
		}

		case NONRKPAYINVOICE_ACTIONS.SET_LINE_ITEMS:
			return {
				...state,
				lineItems: action.payload,
			};

		case NONRKPAYINVOICE_ACTIONS.RESET_LINE_ITEMS_CHANGED_STATE:
			return {
				...state,
				lineItems: state.lineItems.map(({ _changed, ...item }) => ({
					...item,
					Fees: item.Fees.map(({ _changed: _feeChanged, _totalModified, ...fee }) => fee),
				})),
			};

		case NONRKPAYINVOICE_ACTIONS.HANDLE_INOVICE_DRAFT_TOTALS: {
			const data = action.payload;

			const {
				Fees,
				Items,
				TotalOfficerPay,
				Subtotal,
				CoordinationFeesTotal,
				AgencyFeesTotal,
				VehicleFeesTotal,
				EquipmentFeesTotal,
				MiscellaneousFeesTotal,
			} = data;

			const mapDraftInvoiceFeesToFees = draftInvoiceFees => {
				const { additionalFees } = state.totals;

				return draftInvoiceFees.reduce((acc, f) => {
					const index = f.Index;
					if (additionalFees[index]) {
						acc.push({
							...additionalFees[index],
							Total: f.Total,
						});
					}
					return acc;
				}, []);
			};

			const mapDraftFeesToItemFees = (lineItem, draftFees) =>
				draftFees.reduce((acc, draftFee) => {
					const index = draftFee.Index;
					if (lineItem.Fees[index]) {
						acc.push({
							...lineItem.Fees[index],
							Total: draftFee.Total,
							_totalModified: lineItem.Fees[index].Total !== draftFee.Total,
							_changed: false,
						});
					}
					return acc;
				}, []);

			const mapItemDraftToItem = draftItems => {
				const updatedLineItems = draftItems.reduce((acc, draftItem) => {
					const index = draftItem.Index;
					if (state.lineItems[index]) {
						acc.push({
							...state.lineItems[index],
							OfficerPayAmount: draftItem.OfficerPay,
							TotalAmount: draftItem.Total,
							FeeTotal: draftItem.TotalFees,
							Fees: mapDraftFeesToItemFees(state.lineItems[index], draftItem.Fees),
							_changed: false,
						});
					}
					return acc;
				}, []);
				return updatedLineItems.sort((a, b) =>
					utils.compareLineItemsByDateAndOfficerName(a, b),
				);
			};

			const { tax, serviceFee, workerCompensationFee, appliedPayments } = state.totals;

			// TODO: Remove this calculation once we have the new total due coming from the API
			const newTotalDue = utils.bankersRound(
				Subtotal + (tax || 0) + (serviceFee || 0) + (workerCompensationFee || 0),
			);

			// TODO: Remove this calculation once we have the new balance coming from the API
			const newBalance = utils.bankersRound(newTotalDue - appliedPayments);

			return {
				...state,
				showFeesBreakdown: true,
				lineItems: mapItemDraftToItem(Items),
				totals: {
					...state.totals,
					hourlyTotal: TotalOfficerPay,
					additionalFees: mapDraftInvoiceFeesToFees(Fees),
					totalDue: newTotalDue,
					balance: newBalance,
					agencyFeesTotal: AgencyFeesTotal,
					vehicleFeesTotal: VehicleFeesTotal,
					equipmentFeesTotal: EquipmentFeesTotal,
					coordinationFeesTotal: CoordinationFeesTotal,
					miscPersonnelFeesTotal: MiscellaneousFeesTotal,
					subTotal: Subtotal,
				},
			};
		}

		case NONRKPAYINVOICE_ACTIONS.SET_NEW_LINE_FEE_TOGGLER: {
			const { jobAssignmentId, newFee } = action.payload;
			return {
				...state,
				newLineFeeToggler: {
					...state.newLineFeeToggler,
					[jobAssignmentId]: newFee,
				},
			};
		}

		case NONRKPAYINVOICE_ACTIONS.TOGGLE_LINE_FEES: {
			const { jobAssignmentId } = action.payload;
			return {
				...state,
				lineFeeToggler: {
					...state.lineFeeToggler,
					[jobAssignmentId]: !state.lineFeeToggler[jobAssignmentId],
				},
			};
		}

		case NONRKPAYINVOICE_ACTIONS.SET_LINE_ITEM_POSITION: {
			const { jobAssignmentId, property, value } = action.payload;
			const [...oldLineItems] = state.lineItems;
			const newLineItems = oldLineItems.map(item => {
				if (item.JobAssignmentId === jobAssignmentId) {
					return {
						...item,
						[property]: value,
						_changed: true,
					};
				}
				return item;
			});

			return {
				...state,
				lineItems: newLineItems,
			};
		}

		case NONRKPAYINVOICE_ACTIONS.REMOVE_LINE_ITEM: {
			const { jobEventId } = action.payload;
			let uniqueOfficers = [];

			const lineItemsFiltered = state.lineItems.filter(
				item => item.JobEventId !== jobEventId,
			);
			if (state.officerViewList.length > 0) {
				// If viewing the invoice grouped by officer, we need to sort by officer ID to maintain order.
				// Additionaly, we want to remove any officers that are no longer on the invoice after deleting a job
				lineItemsFiltered.sort((a, b) => (b.OfficerId || 0) - (a.OfficerId || 0));
				uniqueOfficers = [
					...new Set(lineItemsFiltered.map(i => `${i.OfficerName}_${i.OfficerId}`)),
				].map(comb => {
					const [name, id] = comb.split("_");
					return { OfficerName: name, OfficerId: parseInt(id, 10) || null };
				});
			} else {
				lineItemsFiltered.sort((a, b) => utils.compareLineItemsByDateAndOfficerName(a, b));
			}
			const assignmentIds = state.lineItems
				.filter(item => item.JobEventId !== jobEventId)
				.map(item => item.JobAssignmentId);
			const lineFeeTogglerFiltered = Object.fromEntries(
				Object.entries(state.lineFeeToggler).filter(
					([key]) => !assignmentIds.includes(key),
				),
			);
			const newLineFeeTogglerFiltered = Object.fromEntries(
				Object.entries(state.newLineFeeToggler).filter(
					([key]) => !assignmentIds.includes(key),
				),
			);

			return {
				...state,
				lineItems: lineItemsFiltered,
				lineFeeToggler: lineFeeTogglerFiltered,
				newLineFeeToggler: newLineFeeTogglerFiltered,
				officerViewList: uniqueOfficers,
			};
		}

		case NONRKPAYINVOICE_ACTIONS.HANDLE_CLIENT_CHANGE:
			return {
				...state,
				lineItems: [],
				lineFeeToggler: {},
				showDelete: "",
				newLineFeeToggler: {},
				billTo: {
					streetAddress: "",
					city: "",
					stateId: "",
					stateName: "",
					stateAbbreviation: "",
					zip: "",
					phone: "",
					email: "",
					contact: "",
				},
				totals: {
					hourlyTotal: 0,
					feesTotal: 0,
					additionalFees: [],
					totalDue: 0,
					appliedPayments: 0,
					payments: 0,
					refunds: 0,
					tax: 0,
					serviceFee: 0,
					workerCompensationFee: 0,
					balance: 0,
				},
			};

		case NONRKPAYINVOICE_ACTIONS.SET_BILL_TO_STATE_DATA: {
			const { stateId, stateName, stateAbbreviation } = action.payload;
			return {
				...state,
				billTo: {
					...state.billTo,
					stateId,
					stateName,
					stateAbbreviation,
				},
			};
		}

		case NONRKPAYINVOICE_ACTIONS.SET_BILL_TO_PROPERTY_DATA:
			return {
				...state,
				billTo: {
					...state.billTo,
					[action.payload.property]: action.payload.value,
				},
			};

		case NONRKPAYINVOICE_ACTIONS.SET_FROM_PROPERTY_DATA:
			return {
				...state,
				from: {
					...state.from,
					[action.payload.property]: action.payload.value,
				},
			};

		case NONRKPAYINVOICE_ACTIONS.SET_INVOICE_PROPERTY_DATA:
			return {
				...state,
				[action.payload.property]: action.payload.value,
			};

		case NONRKPAYINVOICE_ACTIONS.HANDLE_INVOICE_DATA: {
			const { data, organizationLogo } = action.payload;

			let IssueDate = utils.normalizeDate(data.IssueDate);
			let DueDate = utils.normalizeDate(data.DueDate);

			if (utils.isDesktopSafari || utils.isIE) {
				if (IssueDate)
					IssueDate = utils.formatDate(
						new Date(`${IssueDate}T00:00:00`),
						"en-US",
						undefined,
						"2-digit",
					);
				if (DueDate)
					DueDate = utils.formatDate(
						new Date(`${DueDate}T00:00:00`),
						"en-US",
						undefined,
						"2-digit",
					);
			}

			let { Items: lineItemsData } = data;

			if (data.IsEstimate) {
				lineItemsData = lineItemsData.map((item, index) => ({
					...item,
					JobAssignmentId: item.JobAssignmentId || `${item.JobEventId}_${index}`,
					OfficerName: item.OfficerName || "TBD",
				}));
			}

			const lineFeeTogglerData = {};
			const newLineFeeTogglerData = {};
			let showDeleteInput;

			lineItemsData.forEach(item => {
				if (!lineFeeTogglerData[item.JobAssignmentId])
					lineFeeTogglerData[item.JobAssignmentId] = false;
				if (!newLineFeeTogglerData[item.JobAssignmentId])
					newLineFeeTogglerData[item.JobAssignmentId] = undefined;
				if (!item.JobEventId) showDeleteInput = "";
			});

			const {
				ClientLocationAddress,
				Subtotal,
				GrandTotal,
				Tax,
				ServiceFee,
				Balance,
				WorkerCompensationFee,
				AgencyFeesTotal,
				VehicleFeesTotal,
				EquipmentFeesTotal,
				MiscellaneousFeesTotal,
				CoordinationFeesTotal,
				OfficerPayTotal,
			} = data;

			return {
				...state,
				archived: data.Archived,
				activeDisputeId: data.ActiveDisputeId,
				finalized: data.Finalized,
				estimateFinalized: data.EstimateFinalized,
				voided: data.Voided,
				amended: data.Amended,
				disputed: data.Disputed,
				electronicPaymentsMade: data.ElectronicPaymentsMade,
				issueDate: IssueDate,
				dueDate: DueDate,
				isEstimate: data.IsEstimate,
				sentDateTimeUTC: data.SentDateTimeUTC,
				statusId: data.StatusId || null,
				invoiceId: data.Id,
				invoiceNumber: data.InvoiceNumber || "",
				notesToClient: data.NotesToClient || "",
				invoiceDisclaimer: data.InvoiceDisclaimer,
				profilePicUrl: organizationLogo || "",
				typeId: data.TypeId,
				from: {
					name: data.OrganizationName || "",
					address: data.OrganizationAddress || "",
					phone: data.OrganizationPhoneNumber || "",
					email: data.OrganizationEmailAddress || "",
					contact: data.OrganizationContactName || "",
				},
				billTo: {
					streetAddress: ClientLocationAddress?.StreetAddress || "",
					city: ClientLocationAddress?.City || "",
					stateId: ClientLocationAddress?.StateId || "",
					stateName: ClientLocationAddress?.StateName || "",
					stateAbbreviation: ClientLocationAddress?.StateAbbreviation || "",
					zip: ClientLocationAddress?.Zip || "",
					phone: data.ClientPhoneNumber || "",
					email: data.ClientEmailAddress || "",
					contact: data.ClientContactName || "",
				},
				prePay: data.RequirePrepayment,
				invoiceVersion: data.Version,
				lineItems: lineItemsData.sort((a, b) =>
					utils.compareLineItemsByDateAndOfficerName(a, b),
				),
				lineFeeToggler: lineFeeTogglerData,
				newLineFeeToggler: newLineFeeTogglerData,
				showDelete: showDeleteInput,
				showFeesBreakdown: true,
				totals: {
					...state.totals,
					hourlyTotal: OfficerPayTotal,
					agencyFeesTotal: AgencyFeesTotal,
					vehicleFeesTotal: VehicleFeesTotal,
					equipmentFeesTotal: EquipmentFeesTotal,
					coordinationFeesTotal: CoordinationFeesTotal,
					miscPersonnelFeesTotal: MiscellaneousFeesTotal,
					additionalFees: data.Fees.sort((a, b) => a.Id - b.Id),
					totalDue: GrandTotal,
					tax: Tax,
					serviceFee: ServiceFee,
					workerCompensationFee: WorkerCompensationFee,
					balance: Balance,
					subTotal: Subtotal,
					payments: state.totals.payments || 0,
					refunds: state.totals.refunds || 0,
				},
				estimateId: data.EstimateId,
				estimateNumber: data.EstimateNumber,
			};
		}

		case NONRKPAYINVOICE_ACTIONS.OVERRIDE_LINE_ITEMS: {
			let newShowDelete;
			const prevOfficerList = [...state.officerViewList];

			const itemsSorted = action.payload.sort((a, b) =>
				prevOfficerList.length === 0
					? (b.OfficerId || 0) - (a.OfficerId || 0)
					: utils.compareLineItemsByDateAndOfficerName(a, b),
			);

			itemsSorted.forEach(item => {
				if (!item.JobEventId) newShowDelete = "";
			});

			const uniqueOfficers = [
				...new Set(itemsSorted.map(i => `${i.OfficerName}_${i.OfficerId}`)),
			].map(comb => {
				const [name, id] = comb.split("_");
				return { OfficerName: name, OfficerId: parseInt(id, 10) || null };
			});

			return {
				...state,
				lineItems: itemsSorted,
				lineFeeToggler: {},
				newLineFeeToggler: {},
				showDelete: newShowDelete,
				officerViewList: prevOfficerList.length > 0 ? uniqueOfficers : prevOfficerList,
			};
		}

		case NONRKPAYINVOICE_ACTIONS.ADD_LINE_ITEMS: {
			let newShowDelete;
			const lineFeeTogglerCopy = { ...state.lineFeeToggler };
			const newLineFeeTogglerCopy = { ...state.newLineFeeToggler };
			const prevOfficerList = [...state.officerViewList];

			const oldItems = state.lineItems.map(oldItem => {
				const newItem = action.payload.find(
					ni => ni.JobAssignmentId === oldItem.JobAssignmentId,
				);
				if (newItem?.TimeCard) return { ...oldItem, Hours: newItem.Hours };
				return oldItem;
			});

			const newItems = action.payload.filter(
				item =>
					!state.lineItems.some(
						currentItem => currentItem.JobAssignmentId === item.JobAssignmentId,
					),
			);
			const newLineItems = [...oldItems, ...newItems].sort((a, b) =>
				prevOfficerList.length === 0
					? (b.OfficerId || 0) - (a.OfficerId || 0)
					: utils.compareLineItemsByDateAndOfficerName(a, b),
			);

			newLineItems.forEach(item => {
				if (!lineFeeTogglerCopy[item.JobAssignmentId])
					lineFeeTogglerCopy[item.JobAssignmentId] = false;
				if (!newLineFeeTogglerCopy[item.JobAssignmentId])
					newLineFeeTogglerCopy[item.JobAssignmentId] = undefined;
				if (!item.JobEventId) newShowDelete = "";
			});

			const uniqueOfficers = [
				...new Set(newLineItems.map(i => `${i.OfficerName}_${i.OfficerId}`)),
			].map(comb => {
				const [name, id] = comb.split("_");
				return { OfficerName: name, OfficerId: parseInt(id, 10) || null };
			});

			return {
				...state,
				lineItems: newLineItems,
				lineFeeToggler: lineFeeTogglerCopy,
				newLineFeeToggler: newLineFeeTogglerCopy,
				showDelete: newShowDelete,
				officerViewList: prevOfficerList.length > 0 ? uniqueOfficers : prevOfficerList,
			};
		}

		case NONRKPAYINVOICE_ACTIONS.SET_PAYMENT_DATA:
			return {
				...state,
				totals: {
					...state.totals,
					appliedPayments: action.payload.appliedPayments,
					payments: action.payload.payments || 0,
					refunds: action.payload.refunds || 0,
				},
			};

		case NONRKPAYINVOICE_ACTIONS.SET_BILLING_CONTACT: {
			const {
				StreetAddress1,
				City,
				StateId,
				State,
				Zipcode,
				MobilePhone,
				EmailAddress,
				FirstName,
				LastName,
			} = action.payload;
			return {
				...state,
				billTo: {
					streetAddress: StreetAddress1 || state.billTo.streetAddress,
					city: City || state.billTo.city,
					stateId: StateId || state.billTo.stateId,
					stateName: State || state.billTo.stateName,
					zip: Zipcode || state.billTo.zip,
					phone: MobilePhone ? utils.formatPhoneNumber(MobilePhone) : state.billTo.phone,
					email: EmailAddress || state.billTo.email,
					contact:
						(FirstName || LastName) && !state.billTo.contact
							? `${FirstName || ""}${!!FirstName && !!LastName ? " " : ""}${LastName || ""}`
							: state.billTo.contact,
				},
			};
		}

		default:
			return state;
	}
};
